import React, { useState, useEffect, useReducer } from "react"
import {
  Card,
  Row,
  Col,
  Radio,
  Button,
  Space,
  Spin,
  Typography,
  Divider,
  Flex,
  Tag,
} from "antd"
import {
  FileSearchOutlined,
  CalendarOutlined,
  FilterOutlined,
  PrinterOutlined,
} from "@ant-design/icons"
import { initReport } from "helpers/service_helper"
import { CityFromSection } from "hooks/returnCityName"
import { isNumber } from "lodash"
import moment from "moment"
import { connect } from "react-redux"
import { getEngInvoiceReport } from "store/actions"
import StiReport from "../../../../assets/reports/accounting/EngInvoiceReport.mrt"
import StiReportMinimal from "../../../../assets/reports/accounting/EngInvoiceReport-minimal.mrt"
import Localizations from "../../../../locales/fa/fa.xml"
import { loadStimulsoftScripts } from "helpers/stimulsoftLoader"
import { PersianDatePickerInline } from "components/Common/PersianDatePickerInline"


const { Title, Text } = Typography

const Reports = props => {
  const { lstEngInvoiceReport, loading, reportType } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      projectLevelEnum: 1,
      selectReport: 0,
    }
  )

  const ensureStimulsoftAndInit = async (reportData, groupReport) => {
    await loadStimulsoftScripts()
    if (groupReport === 0) initReport(StiReport, reportData, Localizations)
    else initReport(StiReportMinimal, reportData, Localizations)
  }

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(null), 3000)
      return () => clearTimeout(timer)
    }
  }, [errorMessage])

  const handleInput = evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (newValue == "on") newValue = evt.target.checked

    const inputType = evt.target.attributes?.type?.value

    if (inputType === "text") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }
    if (inputType === "number") newValue = +newValue
    if (inputType === "radio") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
      if (isNumber(parseInt(newValue))) newValue = +newValue
    }
    setFormInput({ [name]: newValue })
  }

  useEffect(() => {
    if (lstEngInvoiceReport.length > 0) {
      const reportData = lstEngInvoiceReport.map(c => ({
        ...c,
        cityName: CityFromSection(c.engineer.idSection),
        engFullName: c.engineer.fullName,
        idEng: c.engineer.id,
      }))
      ensureStimulsoftAndInit(reportData, formInput.selectReport)
    }
  }, [lstEngInvoiceReport, formInput.selectReport])

  const prepareReport = async () => {
    const now = moment()
    await props.onGetEngInvoiceReport({
      engId: "ec75cf4c-b612-40fd-885c-f89d2ae2aad8",
      startDate: startDate.gregorian || now.format("YYYY-MM-DD"),
      endDate: endDate.gregorian || now.format("YYYY-MM-DD"),
    })
  }

  return (
    <div style={{ padding: "24px" }}>
      {/* Filters Card */}
      <Card
        style={{
          borderRadius: 12,
          marginBottom: 24,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <Flex align="center" gap={8} style={{ marginBottom: 20 }}>
          <FilterOutlined style={{ fontSize: 18, color: "#667eea" }} />
          <Title level={5} style={{ margin: 0 }}>
            فیلترهای گزارش
          </Title>
        </Flex>

        <Row gutter={[16, 16]}>
          {/* Report Type Selection */}
          <Col xs={24} md={24}>
            <Space direction="vertical" size={8} style={{ width: "100%" }}>
              <Text strong>نوع گزارش:</Text>
              <Radio.Group
                name="selectReport"
                value={formInput.selectReport}
                onChange={handleInput}
                buttonStyle="solid"
              >
                <Radio.Button value={0}>
                  <FileSearchOutlined style={{ marginLeft: 6 }} />
                  گروه بندی پرونده
                </Radio.Button>
                <Radio.Button value={1}>
                  <FileSearchOutlined style={{ marginLeft: 6 }} />
                  بدون گروه بندی
                </Radio.Button>
              </Radio.Group>
            </Space>
          </Col>

          <Col xs={24}>
            <Divider style={{ margin: "12px 0" }} />
          </Col>

          {/* Date Range */}
          <Col xs={24} sm={12}>
            <Space direction="vertical" size={8} style={{ width: "100%" }}>
              <Flex align="center" gap={6}>
                <CalendarOutlined style={{ color: "#667eea" }} />
                <Text strong>از تاریخ:</Text>
              <PersianDatePickerInline setPersianDate={setStartDate} isPortal={true} />
              </Flex>
            </Space>
          </Col>

          <Col xs={24} sm={12}>
            <Space direction="vertical" size={8} style={{ width: "100%" }}>
              <Flex align="center" gap={6}>
                <CalendarOutlined style={{ color: "#667eea" }} />
                <Text strong>تا تاریخ:</Text>
              <PersianDatePickerInline setPersianDate={setEndDate} isPortal={true} />

              </Flex>
            </Space>
          </Col>

          {/* Action Button */}
          <Col xs={24}>
            <Divider style={{ margin: "12px 0" }} />
            <Flex justify="space-between" align="center" wrap="wrap" gap={12}>
              <Space>
                {startDate && (
                  <Tag color="blue">
                    از: {startDate.formatted || "نامشخص"}
                  </Tag>
                )}
                {endDate && (
                  <Tag color="green">
                    تا: {endDate.formatted || "نامشخص"}
                  </Tag>
                )}
              </Space>
              <Button
                type="primary"
                size="large"
                icon={<PrinterOutlined />}
                loading={loading}
                onClick={prepareReport}
                style={{
                  borderRadius: 8,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
                  height: 40,
                  paddingInline: 24,
                }}
              >
                تهیه گزارش
              </Button>
            </Flex>
          </Col>
        </Row>
      </Card>

      {/* Report Viewer */}
      {loading && (
        <Card
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            minHeight: 400,
          }}
        >
          <Flex justify="center" align="center" style={{ minHeight: 400 }}>
            <Space direction="vertical" align="center" size={16}>
              <Spin size="large" />
              <Text type="secondary">در حال تهیه گزارش...</Text>
            </Space>
          </Flex>
        </Card>
      )}

      {!loading && lstEngInvoiceReport.length > 0 && (
        <Card
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
          bodyStyle={{ padding: 16 }}
        >
          <div
            style={{
              maxWidth: "100%",
              overflowX: "auto",
            }}
            id="viewer"
          ></div>
        </Card>
      )}

      {!loading && lstEngInvoiceReport.length === 0 && (
        <Card
          style={{
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            minHeight: 300,
          }}
        >
          <Flex justify="center" align="center" style={{ minHeight: 300 }}>
            <Space direction="vertical" align="center" size={16}>
              <FileSearchOutlined
                style={{ fontSize: 64, color: "#d9d9d9" }}
              />
              <Text type="secondary" style={{ fontSize: 16 }}>
                هیچ گزارشی یافت نشد. لطفاً فیلترها را تنظیم کرده و دوباره تلاش
                کنید.
              </Text>
            </Space>
          </Flex>
        </Card>
      )}
    </div>
  )
}

const mapStateToProps = ({ Accounting }) => ({
  lstEngInvoiceReport: Accounting.lstEngInvoiceReport,
  error: Accounting.error,
  success: Accounting.success,
  loading: Accounting.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetEngInvoiceReport: values => dispatch(getEngInvoiceReport(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
